export default __webpack_public_path__ + "static/_CAT3918-66856b8b4b0cfa1d927bd64a09a3df58.jpg";